import React from 'react';
import Isvg from 'react-inlinesvg';
import {
    Col,
    Container,
    Row
} from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import garbageIcon from '../../assets/garbage.svg';
import pushIcon from '../../assets/push.svg';
import Page from '../../containers/page';
import FormBuilder from '../../form-builder';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';

import DeleteModal from '../../components/deleteModal';

import arrayMove from 'array-move';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { required } from '../../form-builder/validation';

const SortableItem = SortableElement(({ value, className }) => <li className={className}> <h6> {value.title}</h6></li>);

const SortableList = SortableContainer(({ items, lang, dragIndex }) => {
    return (
        <ul className="sort-list">
            {items.map((value, index) => (
                <SortableItem parent={index} className={dragIndex === index ? 'drag' : null} key={`item-${value}`} index={index} value={value} lang={lang} itemIndex={index} />
            ))}
        </ul>
    );
});
class Screen extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            articlesList: true,
            articleForm: false,
            total: 20,
            modules: [],
            matches: [],
            sortItems: [],
            items: [

            ]
        }
    }

    // SORT START
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({ sortItems }) => ({
            sortItems: arrayMove(sortItems, oldIndex, newIndex),
            dragIndex: null
        }));
    };

    updatePosition = () => {
        let positions = [];
        let sortItems = this.state.sortItems;
        for (let i = 0; i < sortItems.length; i++) {
            positions.push({
                _id: sortItems[i]._id,
                position: i
            });

        }
        this._api('save-sort', { positions }, () => {
            if (typeof window != 'undefined') {
                window.location.reload()
            }
        });
    }

    // SORT END

    componentDidMount() {
        this._onLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }
    }

    render() {
        let params = this._getParams();
        // console.log(this.state.sortItems)

        return (
            <div>
                <div className="section-title title-options">
                    <h1>Poll pages</h1>
                </div>

                <Container fluid style={{ paddingRight: 0 }}>
                    <DeleteModal
                        isOpen={this.state.deleteModal}
                        toggle={() => this.setState({ deleteModal: null })}
                        handler={() => {
                            this._api('api3', { data: this.state.deleteModal._id }, () => {
                                this.setState({ groupsForm: {} }, () => { this._onLoad(); this.setState({ deleteModal: null }) })
                            });
                        }} >
                        Delete page <strong>{this.state.deleteModal ? this.state.deleteModal.name : ''}</strong> ?
                    </DeleteModal>
                    <DeleteModal
                        isOpen={this.state.appPush}
                        toggle={() => this.setState({ appPush: null })}
                        handler={() => {
                            this._api('push', { data: this.state.appPush._id }, () => {
                                this.setState({ groupsForm: {} }, () => { this._onLoad(); this.setState({ appPush: null }) })
                            });
                        }} >
                        Send notification for <strong>{this.state.appPush ? this.state.appPush.title : ''}</strong> ?
                    </DeleteModal>

                    <Row>
                        <Col lg="6">
                            <FormBuilder
                                registerSubmitAction={(submit) => this.submit = submit}
                                classNameForm={"add-form-container"}
                                // headerForm={"Artikal".translate(this.props.lang)}
                                addButtonText={'Add'.translate(this.props.lang)}
                                onSubmit={(dat) => {

                                    let data = { ...dat };



                                    if (this.state.form && this.state.form._id) {

                                        this._api('api4', { data: data }, () => {
                                            this.setState({ form: null }, () => { this._onLoad(); })
                                        });
                                    } else {

                                        this._api('api2', { data: data }, () => {
                                            this.setState({ form: null }, () => { this._onLoad() })
                                        });
                                    }
                                }}
                                initialValues={this.state.form ? this.state.form : null}
                                fields={[
                                    {
                                        type: 'row',
                                        children: [
                                            {
                                                type: 'col',
                                                width: { lg: 12, sm: 12, xs: 12 },
                                                children: [
                                                    {
                                                        type: 'block',
                                                        header: 'Poll info'.translate(this.props.lang),
                                                        children: [
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'select',
                                                                        name: 'match',
                                                                        label: 'Match',
                                                                        asyncValidation: true,
                                                                        values: [{ name: 'Choose match', value: null }, ...this.state.matches.map((item) => { return { value: item._id, name: item.teamObject[0].name + ' - ' + item.teamObject[1].name } })],
                                                                        validate: [
                                                                            required('Required!'),
                                                                        ]
                                                                    },

                                                                ]
                                                            },

                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'question',
                                                                        label: 'Question',
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                            required('Required!'),
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'answer[0]',
                                                                        label: `Answer 1 [${this.state.form && this.state.form.votes && this.state.form.votes[0] ? this.state.form.votes[0] : 0}]`,
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'answer[1]',
                                                                        label: `Answer 2 [${this.state.form && this.state.form.votes && this.state.form.votes[1] ? this.state.form.votes[1] : 0}]`,
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'answer[2]',
                                                                        label: `Answer 3 [${this.state.form && this.state.form.votes && this.state.form.votes[2] ? this.state.form.votes[2] : 0}]`,
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'answer[3]',
                                                                        label: `Answer 4 [${this.state.form && this.state.form.votes && this.state.form.votes[3] ? this.state.form.votes[3] : 0}]`,
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'answer[4]',
                                                                        label: `Answer 5 [${this.state.form && this.state.form.votes && this.state.form.votes[4] ? this.state.form.votes[4] : 0}]`,
                                                                        asyncValidation: true,
                                                                        validate: [
                                                                        ]
                                                                    },

                                                                ]
                                                            },
                                                            {
                                                                type: 'col',
                                                                width: { lg: 12, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'p',
                                                                        text: 'The number of votes per answer is in [x] next to the answer it self.'
                                                                    }
                                                                ]
                                                            },

                                                            {
                                                                type: 'col',
                                                                width: { lg: 6, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'switch',
                                                                        name: 'isOnHomePage',
                                                                        next: 'level',
                                                                        label: 'Home Page',
                                                                    },

                                                                ]
                                                            },




                                                            {
                                                                type: 'col',
                                                                width: { lg: 6, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'switch',
                                                                        name: 'active',
                                                                        next: 'level',
                                                                        label: 'Active',
                                                                    },

                                                                ]
                                                            },

                                                            {
                                                                type: 'col',
                                                                width: { lg: 6, sm: 12, xs: 12 },
                                                                children: [
                                                                    {
                                                                        type: 'text',
                                                                        name: 'intervalPoll',
                                                                        next: 'level',
                                                                        label: 'Interval days',
                                                                    },

                                                                ]
                                                            },


                                                        ]
                                                    },



                                                ],

                                            },
                                            {
                                                type: 'button',
                                                width: { lg: 12, sm: 6, xs: 6 },
                                                action: 'submit',
                                                children: 'Save',
                                                className: 'form-button',
                                            },
                                        ]
                                    },


                                ]}
                            ></FormBuilder>
                        </Col>
                        <Col lg="6">
                            <div className="table-modifed ml-15">
                                <ListBuilder
                                    tabs={false}
                                    sort={false}
                                    header={'List'}
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', name: 'question', label: 'Question'.translate(this.props.lang), multilang: false, allowSort: true },
                                        { type: 'text', name: 'matchObject.teamObject[0].name', label: 'TEAM #1'.translate(this.props.lang), multilang: false, allowSort: true },
                                        { type: 'text', name: 'matchObject.teamObject[1].name', label: 'TEAM #2'.translate(this.props.lang), multilang: false, allowSort: true },

                                    ]}
                                    items={this.state.items}
                                    actions={
                                        [
                                            {
                                                component: <Isvg src={editIcon} className="delete-icon" />,
                                                onClick: (item) => {




                                                    this.setState({ form: null }, () => this.setState({ form: item }))

                                                }
                                                //onClick: (item) => console.log(item)
                                            },
                                            {
                                                component: <Isvg src={pushIcon} className="delete-icon" />,
                                                onClick: (item) => this.setState({ appPush: item })
                                            },

                                            {
                                                component: <Isvg src={garbageIcon} className="delete-icon" />,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                            </div>

                            {/* SORT START */}
                            {/* <div className="sort-modules-wrap">
                                <div className="sort-modules-title">
                                    <h4>Sort</h4>
                                    <button onClick={this.updatePosition}>
                                        <div className="option green">
                                            <Isvg src={saveIcon} />
                                        </div>
                                        <span>Save</span>
                                    </button>
                                </div>

                                <SortableList onSortStart={({ node, index }) => {
                                    this.setState({ dragIndex: index })
                                }}

                                    dragIndex={this.state.dragIndex}
                                    hideSortableGhost={false}
                                    lang={this.props.lang}
                                    items={this.state.sortItems}
                                    onSortEnd={this.onSortEnd} />

                            </div> */}
                            {/* SORT END */}
                        </Col>
                    </Row>
                </Container>

            </div >
        )
    }
}

export default Page(Screen);
